import React from 'react'
import * as styles from './SubMainTitle.module.scss'
import cn from 'classnames'

const SubMainTitle = ({ text, className }) => {
  return <p className={cn(styles.par, className)}>{text}</p>
}
export default SubMainTitle
